import { WaterConnectedTo, WaterUnitInfoDto } from "shared/types/water-info";

export const calculateWaterUnitInfoStatus = (waterUnitInfo: WaterUnitInfoDto) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    if (waterUnitInfo.connectedTo === WaterConnectedTo.PRIVATE_SYSTEM) {
        dotValues.green.count++;
        dotValues.green.labels.push("Wateraansluiting op privé systeem");

        if(waterUnitInfo.waterMeters && waterUnitInfo.waterMeters.length > 0) {
            dotValues.green.count++;
            dotValues.green.labels.push("Watermeters ingevuld");
        } else {
            dotValues.red.count++;
            dotValues.red.labels.push("Geen watermeters ingevuld");
        }
    } else if (waterUnitInfo.connectedTo === WaterConnectedTo.CENTRAL_SYSTEM) {
        dotValues.green.count++;
        dotValues.green.labels.push("Wateraansluiting op centraal systeem");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Onbekend op welk systeem het water is aangesloten (privaat of collectief)");
    }

    return dotValues;
};
